const sports = [
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "Amit Kamath",
        "title": "Asian Games 2023 Live Updates: Blue Tigers move on to RO16, Nikhat Zareen wins her bout in boxing round 1, rowers and shooters win medals - The Indian Express",
        "description": "Asian Games 2023 Day 1 Highlights: The women's cricket team assured themselves a spot in the final while Nikhat Zareen and the men's football team moved into the next round of their respective events",
        "url": "https://indianexpress.com/article/sports/sport-others/asian-games-2023-day-1-live-updates-ind-vs-ban-cricket-hockey-nikhat-zareen-boxing-badminton-rowing-shooting-8953208/",
        "urlToImage": "https://images.indianexpress.com/2023/09/Asian-games-Day-1.jpg",
        "publishedAt": "2023-09-24T14:22:00Z",
        "content": "Mihir Vasavda at Asian Games: Sick man of East Asia? From Bruce Lee to Chinese athletes, Hangzhou 2023 to deliver political and sporting answers\r\n Hangzhou 2022 - Opening Ceremony - Hangzhou Olympic … [+963 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "Sportstar",
        "title": "India vs Myanmar HIGHLIGHTS, Asian Games updates: IND 1-1 MYA; India qualifies for Round of 16 - Sportstar",
        "description": null,
        "url": "https://sportstar.thehindu.com/asian-games/india-vs-myanmar-live-streaming-score-updates-asian-games-2023-football-match-hangzhou-2022-highlights-lineups/article67340812.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T13:18:24Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Cricket.one"
        },
        "author": "Aakash Saini",
        "title": "Shubman Gill Surpasses Hashim Amla, Babar Azam For 'Huge ODI' Record With Indore Ton - OneCricket",
        "description": "Indian batsman Shubman Gill continues to scale new ODI landmarks as he went past batting greats Hashim Amla and Babar Azam for a huge world record through his Indore batting masterclass.",
        "url": "https://cricket.one/match-hub/shubman-gill-surpasses-hashim-amla-babar-azam-for-huge-odi-record-with-indore-ton/65102242b81c04783aba902d",
        "urlToImage": "https://ik.imagekit.io/c7syb8qpjp/oc/oc-dashboard/news-images-prod/1695555906406_AP23267408683268.jpg",
        "publishedAt": "2023-09-24T11:49:22Z",
        "content": "Shubman Gill in action against Australia in Indore (x.com)\r\nShubman Gill soared past former South African batsman Hashim Amla and Pakistan great Babar Azam for all-time ODI record with his Indore mas… [+2333 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "ESPN India"
        },
        "author": "Shyam Vasudevan",
        "title": "Asian Games: Unusual draw cannot stop the Nikhat Zareen juggernaut - ESPN - ESPN India",
        "description": "Two-time world champion Nikhat Zareen is unbeaten in two years and made light work of Worlds silver medallist Thi Tam Nguyen.",
        "url": "https://www.espn.in/olympics/summer/boxing/story/_/id/38477571/asian-games-unusual-draw-cannot-stop-nikhat-zareen-juggernaut",
        "urlToImage": "https://a.espncdn.com/combiner/i?img=%2Fphoto%2F2023%2F0323%2Fr1148880_1296x729_16%2D9.jpg",
        "publishedAt": "2023-09-24T11:35:00Z",
        "content": "World champion Nikhat Zareen began her Asian Games campaign against world silver medallist Thi Tam Nguyen on Sunday. While Nikhat won the bout, a match-up of this quality - between the two best boxer… [+2828 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Virat Kohli or Rohit Sharma? Messi or Ronaldo? Rahul Gandhi tackles rapid fire questions | Mint - Mint",
        "description": "Rahul Gandhi prefers Messi over Ronaldo in football but admits he is not a huge cricket fan.",
        "url": "https://www.livemint.com/news/india/virat-kohli-or-rohit-sharma-messi-or-ronaldo-rahul-gandhi-tackles-rapid-fire-questions-11695553145446.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/PTI09-24-2023-000137A-0_1695553227219_1695553280856.jpg",
        "publishedAt": "2023-09-24T11:28:10Z",
        "content": "Congress leader Rahul Gandhi revealed on Saturday that he prefers football over cricket and Messi over Ronaldo. The remarks were made during a recent media event that saw the Wayanad MP fielding a se… [+1785 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "Jaspreet Sahni",
        "title": "Asian Games: Acclimatization, 'desert storm' behind India's medal rush in rowing - IndiaTimes",
        "description": "Asian Games 2023 News: Rowing involves a plethora of technical intricacies, including concepts like tailwind, headwind, stroke rate, oar angles, arc angles, and force applic",
        "url": "https://timesofindia.indiatimes.com/sports/asian-games-2023/india-asian-games/asian-games-acclimatization-desert-storm-behind-indias-medal-rush-in-rowing/articleshow/103908360.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103908447,width-1070,height-580,imgsize-60598,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T11:18:00Z",
        "content": "19th Asian Games: Indian rowers win silver in Men's Coxed Eight eventIndian rowers secured a second-place finish in the Men's Coxed Eight final event at the 19th Asian Games in Hangzhou, marking thei… [+166 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Sports Desk",
        "title": "Gill pips Sachin with 6th ODI hundred; Iyer scores perfectly-timed ton before WC - Hindustan Times",
        "description": "Iyer and Gill tormented the Cummins-less Aussie attack in Indore to smash their respective centuries while stitching a record 200-plus stand | Cricket",
        "url": "https://www.hindustantimes.com/cricket/ind-vs-aus-shubman-gill-equals-ponting-zooms-past-sachin-tendulkar-6th-odi-century-shreyas-iyer-perfectly-timed-ton-wc-101695550067738.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/India-Australia-Cricket-11_1695550297212_1695550326949.jpg",
        "publishedAt": "2023-09-24T11:14:27Z",
        "content": "Two days back, Shreyas Iyer was left visibly frustrated when he found himself at the wrong end of a run-out mix-up in the opening match of the ODI series against Australia in Mohali. Iyer, who has be… [+3659 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Motogp.com"
        },
        "author": null,
        "title": "WATCH: Marc Marquez crashes out of podium fight! - motogp.com",
        "description": "MotoGP description",
        "url": "https://www.motogp.com/en/videos/2023/09/24/watch-marc-marquez-crashes-out-of-podium-fight/478822",
        "urlToImage": "https://resources.motogp.pulselive.com/photo-resources/2023/09/24/4768f784-0b24-4e3d-b306-a2a41c9e3b48/Screenshot-2023-09-24-at-12.17.56.jpg?width=1200&height=630",
        "publishedAt": "2023-09-24T11:14:27Z",
        "content": "The eight-time World Champion was swarming over Pecco Bagnaia's rear tyre before sliding out of contention in India\r\n24 Sep 2023"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Sports Desk",
        "title": "MotoGP India Grand Prix 2023 Highlights: Bezzecchi wins inaugural race - Hindustan Times",
        "description": "MotoGP India Grand Prix 2023 Highlights: Bezzecchi cruised to victory but Martin and Quartararo battled it out in the last lap for second place.",
        "url": "https://www.hindustantimes.com/sports/others/motogp-india-grand-prix-2023-live-updates-jorge-martin-marc-marquez-marco-bezzecchi-buddh-international-circuit-101695537603619.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/TOPSHOT-MOTO-PRIX-IND-MOTOGP-SPRINT-2_1695538582133_1695538617181.jpg",
        "publishedAt": "2023-09-24T11:11:03Z",
        "content": "MotoGP India Grand Prix 2023 Live updates: The top 10\r\nMotoGP India Grand Prix 2023 Live updates: Bezzecchi, Martin, Quartararo, Binder, Mir, Zarco, Morbidelli, Vinales, Marquez and R. Fernandez in t… [+9 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "NDTV News"
        },
        "author": "NDTV Sports Desk",
        "title": "India vs Australia Live Score, 2nd ODI: Shubman Gill Hits 50, 1-Down India Solid Against Australia - NDTV Sports",
        "description": "India vs Australia Live Score: Shubman Gill and Shreyas Iyer have smashed their respective half-centuries",
        "url": "https://sports.ndtv.com/cricket/ind-vs-aus-live-score-2nd-odi-cricket-match-india-vs-australia-latest-updates-4418669",
        "urlToImage": "https://c.ndtvimg.com/2023-09/77f5si6o_shreyas-iyer-and-shubman-gill-afp_625x300_24_September_23.jpg?im=FitAndFill,algorithm=dnn,width=1200,height=675",
        "publishedAt": "2023-09-24T09:40:05Z",
        "content": "India vs Australia Live Score: Shreyas Iyer and Shubman Gill have smashed their respective half-centuries and have stitched a 150-run partnership. Despite losing the wicket of Ruturaj Gaikwad early i… [+825 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Liverpoolworld.uk"
        },
        "author": "LiverpoolWorld",
        "title": "Seven changes made - Liverpool predicted starting line-up vs West Ham United - gallery - LiverpoolWorld",
        "description": null,
        "url": "https://www.liverpoolworld.uk/sport/football/liverpool/seven-changes-made-liverpool-predicted-starting-line-up-vs-west-ham-united-4346942",
        "urlToImage": null,
        "publishedAt": "2023-09-24T09:03:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Barca Blaugranes"
        },
        "author": "Gill Clark",
        "title": "Five talking points from Barcelona 3-2 Celta Vigo - Barca Blaugranes",
        "description": "Big finish from the hosts",
        "url": "https://www.barcablaugranes.com/2023/9/24/23886975/five-talking-points-from-barcelona-3-2-celta-vigo",
        "urlToImage": "https://cdn.vox-cdn.com/thumbor/oVO02uLgk4dagzVO43LXgg7Ogu4=/0x0:4365x2285/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24947797/1684436673.jpg",
        "publishedAt": "2023-09-24T09:00:00Z",
        "content": "From zeroes to heroes\r\nAfter hammering Betis and Antwerp, scoring 10 goals along the way, Barcelona looked set for a reality check when Celta scored twice to leave Xavis side staring into the face of… [+5026 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Cricket.one"
        },
        "author": "Ritam",
        "title": "[Watch] Ruturaj Gaikwad's Brisk Stay Ended By Josh Hazlewood's Jaffa - OneCricket",
        "description": "One of the world's most accurate fast bowlers, Josh Hazlewood, replaced Pat Cummins to play the second ODI against India. The tall fast bowler had an immediate impact, bowling a good-length delivery in the area of doubt to get Ruturaj Gaikwad to edge.",
        "url": "https://cricket.one/match-hub/watch-ruturaj-gaikwads-brisk-stay-ended-by-josh-hazlewoods-jaffa/650ff66aed198a02e75f2bea",
        "urlToImage": "https://ik.imagekit.io/c7syb8qpjp/oc/oc-dashboard/news-images-prod/1695544920987_Untitled design.jpg",
        "publishedAt": "2023-09-24T08:42:18Z",
        "content": "Josh Hazlewood got the wicket of Ruturaj Gaikwad on Sunday (AP Photos)\r\nIndias second ODI against Australia did not get off to an ideal start on Sunday at Holkar Cricket Stadium in Indore. Unlike las… [+971 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "Tiasa Bhowal",
        "title": "This man’s co-passenger on IndiGo flight was MS Dhoni. Here’s what happened next - India Today",
        "description": "A die-hard MS Dhoni fan had the experience of a lifetime when he shared a flight with the cricketing legend. The fan from Dhoni's hometown, Ranchi, shared his excitement on social media.",
        "url": "https://www.indiatoday.in/trending-news/story/this-mans-co-passenger-on-indigo-flight-was-ms-dhoni-heres-what-happened-2439832-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/this-mans-co-passenger-on-indigo-flight-was-ms-dhoni-245747129-16x9.jpg?VersionId=JkgmLeYSETF6C6WDt_wqcSlqJCG44tPR",
        "publishedAt": "2023-09-24T08:01:42Z",
        "content": "Mahendra Singh Dhoni is one of the most-loved figures in the world of cricket. His admirers are scattered across the globe, and their enthusiasm for him never seems to wane. Recently, one such ardent… [+1655 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "Sportstar",
        "title": "IND vs JPN, HIGHLIGHTS Volleyball Asian Games: India loses 3-0 to Japan, to play 5-6 place playoff match later - Sportstar",
        "description": null,
        "url": "https://sportstar.thehindu.com/asian-games/india-vs-japan-live-score-mens-volleyball-asian-games-2023-streaming-updates-highlights-hangzhou/article67340681.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T07:52:30Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Sports Desk",
        "title": "Revealed: Why Jasprit Bumrah is not playing for India in 2nd ODI vs Australia - Hindustan Times",
        "description": "India will be without the services of their star bowler Jasprit Bumrah in the 2nd ODI match versus Australia, who has been given a break by the team management. | Cricket",
        "url": "https://www.hindustantimes.com/cricket/revealed-why-jasprit-bumrah-is-not-playing-for-india-in-2nd-odi-vs-australia-at-indore-101695539471750.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/AP09-17-2023-000159B-1_1694951365918_1695539485136.jpg",
        "publishedAt": "2023-09-24T07:21:25Z",
        "content": "After a comprehensive win against Australia in the opening match of the three-match series in Mohali last Friday, with the KL Rahul-led side, in absence of senior players in Virat Kohli and Rohit Sha… [+1926 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Sounak Mukhopadhyay",
        "title": "Taking Suryakumar Yadav in the team ‘huge gamble’: Gautam Gambhir explains why | Mint - Mint",
        "description": "Suryakumar Yadav's fifty reignites discussions on his role in the Indian team for the upcoming ODI World Cup.",
        "url": "https://www.livemint.com/sports/cricket-news/taking-suryakumar-yadav-in-the-team-huge-gamble-gautam-gambhir-explains-why-11695539166939.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/CRICKET-IND-AUS-ODI-181_1695539585582_1695539607083.jpg",
        "publishedAt": "2023-09-24T07:15:15Z",
        "content": "Suryakumar Yadav scored a decisive fifty in the opening ODI against Australia on September 22, reigniting discussions on his role in the Indian team for the upcoming ODI World Cup. The Mumbai-born ba… [+2185 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Racingnews365.com"
        },
        "author": null,
        "title": "LIVE: Reaction as Verstappen secures Red Bull title with dominant Japanese victory - Racingnews365.com",
        "description": "Follow the Japanese Grand Prix live. Keep up to date with everything that happens in the race at Suzuka.",
        "url": "https://racingnews365.com/live-2023-f1-japanese-grand-prix",
        "urlToImage": "https://cdn.racingnews365.com/2023/Verstappen/_1800x945_crop_center-center_75_none/SI202309230138.jpg?v=1695528014",
        "publishedAt": "2023-09-24T06:39:00Z",
        "content": "Max Verstappen starts on pole for the Japanese Grand Prix after a sensational qualifying effort at Suzuka.\r\nThe Dutchman lines up alongside McLaren's Oscar Piastri on the front row after the Australi… [+499 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "crash.net"
        },
        "author": "Peter McLaren",
        "title": "MotoGP Warm-up - 2023 MotoGP World Championship round 13 - Buddh International Circuit, India Results - Crash",
        "description": "Warm-up results from the Indian MotoGP at the Buddh International Circuit, round 13 of 20 in the 2023 world championship.",
        "url": "https://www.crash.net/motogp/results/1036621/1/indian-motogp-buddh-warmup-results",
        "urlToImage": "https://cdn.crash.net/styles/large_article/s3/pa/3463101.0008.jpg?itok=tUNcN_th",
        "publishedAt": "2023-09-24T06:19:52Z",
        "content": "<table><tr><td>Indian MotoGP, Buddh International Circuit - Warm-up Results</td></tr><tr><td>Pos</td><td>Rider</td><td>Nat</td><td>Team</td><td>Time/Diff</td><td>Lap</td><td>Max</td></tr><tr><td>1</t… [+5077 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Insidesport.in"
        },
        "author": "Padmaja Srivatsan",
        "title": "Blow to Lankans, Wanindu Hasaranga out of Sri Lanka World Cup Squad - InsideSport",
        "description": "Wanindu Hasaranga suffers another setback as the leg spinner injures hamstring in the training session ahead of the World Cup",
        "url": "https://www.insidesport.in/blow-to-lankans-wanindu-hasaranga-out-of-sri-lanka-world-cup-squad/",
        "urlToImage": "https://www.insidesport.in/wp-content/uploads/2023/09/WhatsApp-Image-2023-09-24-at-10.37.16.jpeg",
        "publishedAt": "2023-09-24T06:15:50Z",
        "content": "Wanindu Hasaranga suffers another setback as the leg spinner injures hamstring in the training session ahead of the World CupIn a massive blow for Sri Lankans, Wanindu Hasaranga is likely to be ruled… [+1711 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Sportskeeda"
        },
        "author": "Aditya Singh",
        "title": "“The most calm and assured player on the pitch” - Rio Ferdinand lauds Manchester United star’s performance in Burnley win - Sportskeeda",
        "description": "Manchester United legend Rio Ferdinand was impressed with defender Jonny Evans' performance against Burnley at Turf Moor in the Premier League on Saturday, September 23.",
        "url": "https://www.sportskeeda.com/football/news-the-calm-assured-player-pitch-rio-ferdinand-lauds-manchester-united-star-s-performance-burnley-win",
        "urlToImage": "https://staticg.sportskeeda.com/editor/2023/09/6a5c4-16955353657698-1920.jpg",
        "publishedAt": "2023-09-24T06:11:00Z",
        "content": "Manchester United legend Rio Ferdinand was impressed with defender Jonny Evans' performance against Burnley at Turf Moor in the Premier League on Saturday, September 23.\r\nThe Red Devils broke their t… [+2312 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India.com"
        },
        "author": "Zee Media Bureau",
        "title": "Happy Birthday Arjun Tendulkar: Top 5 Achievements Of Sachin Tendulkars Son; In Pics - Zee News",
        "description": "Goa and Mumbai Indians cricketer Arjun Tendulkar, who also happens to be the son of legendary Indian cricketer Sachin Tendulkar turned 24 on Sunday. He was born in Mumbai  on September 24 to Sachin and Anjali Tendulkar. He has taken up cricket a full-time pro…",
        "url": "https://zeenews.india.com/photos/sports/happy-birthday-arjun-tendulkar-top-5-achievements-of-sachin-tendulkars-son-in-pics-sara-tendulkar-2666372",
        "urlToImage": "https://english.cdn.zeenews.com/sites/default/files/2023/09/24/1287108-untitled-design-2023-09-24t110203.659.png",
        "publishedAt": "2023-09-24T05:48:00Z",
        "content": "By clicking Accept All Cookies, you agree to the storing of cookies on your device and the processing of information obtained via those cookies (including about your preferences, device and online ac… [+357 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Crictracker.com"
        },
        "author": "CricTracker Staff",
        "title": "SA-W vs NZ-W, 1st ODI: Match Prediction – Who will win today’s match between South Africa women vs New Zealand women? - CricTracker",
        "description": "The first ODI of the upcoming series between South Africa (SA) and New Zealand (NZ) is all set to begin on Sunday, September 24. The South African team are fresh off their success against Pakistan and",
        "url": "https://www.crictracker.com/cricket-match-predictions/sa-w-vs-nz-w-1st-odi-match-prediction-who-will-win-todays-match-between-south-africa-women-vs-new-zealand-women/",
        "urlToImage": "https://media.crictracker.com/media/attachments/1694450941360_South-Africa-women.jpeg",
        "publishedAt": "2023-09-24T05:45:00Z",
        "content": "The first ODI of the upcoming series between South Africa (SA) and New Zealand (NZ) is all set to begin on Sunday, September 24. The South African team are fresh off their success against Pakistan an… [+2776 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Bavarian Football Works"
        },
        "author": "CSmith1919",
        "title": "Daily Schmankerl: The aftermath of Bayern Munich vs. VfL Bochum; Can Harry Kane still break Alan Shearer’s re… - Bavarian Football Works",
        "description": "What a performance from Bayern Munich!",
        "url": "https://www.bavarianfootballworks.com/2023/9/24/23885881/bayern-munich-vs-vfl-bochum-will-harry-kane-manchester-united-fc-barcelona-cancelo-felix-sancho-sane",
        "urlToImage": "https://cdn.vox-cdn.com/thumbor/wXBCA6yFrxUIyxGxJAIzy8J_i_4=/0x0:5184x2714/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24947488/1697675818.jpg",
        "publishedAt": "2023-09-24T05:30:00Z",
        "content": "Bayern Munich thoroughly smashed VfL Bochum in a Bundesliga match-up that looked like it had the potential to get ugly early on and then did. The Bavarians poured it on VfL Bochum in a game that was … [+7141 chars]"
    },
    {
        "source": {
            "id": "espn-cric-info",
            "name": "ESPN Cric Info"
        },
        "author": "Shashank Kishore",
        "title": "Recent Match Report - BDESH (W) vs India (W) 1st Semi-Final 2023 - ESPNcricinfo",
        "description": "India pacer, who was only named as a non-travelling reserve initially, helps skittle Bangladesh for 51",
        "url": "https://www.espncricinfo.com/series/asian-games-women-s-cricket-competition-2023-1398686/india-women-vs-bangladesh-women-1st-semi-final-1399059/match-report",
        "urlToImage": "https://img1.hscicdn.com/image/upload/f_auto/lsci/db/PICTURES/CMS/354200/354283.6.jpg",
        "publishedAt": "2023-09-24T04:18:32Z",
        "content": "ReportIndia pacer, who was only named as a non-travelling reserve initially, helps skittle Bangladesh for 51"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Sounak Mukhopadhyay",
        "title": "‘Jawan’ actor Vijay Sethupathi pulled out of Muttiah Muralitharan’s biopic ‘800’ - here’s why | Mint - Mint",
        "description": "Muttiah Muralitharan's biopic ‘800’ has faced controversy and casting changes, with Madhur Mittal replacing Vijay Sethupathi as the lead.",
        "url": "https://www.livemint.com/news/india/jawan-actor-vijay-sethupathi-pulled-out-of-muttiah-muralitharan-s-biopic-800-here-s-why-11695527492872.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/INDIA-ENTERTAINMENT-CINEMA-BOLLYWOOD-7_1695527646411_1695527659862.jpg",
        "publishedAt": "2023-09-24T04:00:14Z",
        "content": "The producers unveiled the first look of the much-talked-about Muttiah Muralitharan biopic 800 on 17 April 2023, which coincided with the Sri Lankan cricketers birthday. Madhur Mittal is stepping int… [+2682 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Martin, Pecco and Marc's post #TissotSprint conversation !🗣️| 2023 #IndianGP UNHEARD - MotoGP",
        "description": "\"Bezzecchi did 1:44.5 on the last lap\" 👀\"WHAT?\" 🤯Check out the behind the scenes moments as Martin,Pecco and Marquez talk about the #TissotSprint 🙌#Indian...",
        "url": "https://www.youtube.com/watch?v=v08VBBVdaw8",
        "urlToImage": "https://i.ytimg.com/vi/v08VBBVdaw8/maxresdefault.jpg",
        "publishedAt": "2023-09-24T03:30:21Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Thecricketmonthly.com"
        },
        "author": null,
        "title": "The two-man heist - The Cricket Monthly",
        "description": "When Yuvraj Singh and Mohammad Kaif did their team proud in a tall chase in England",
        "url": "https://www.thecricketmonthly.com/story/1376405/the-two-man-heist",
        "urlToImage": "https://p.imgci.com/db/PICTURES/CMS/345000/345052.jpg",
        "publishedAt": "2023-09-24T02:27:19Z",
        "content": "England vs India, NatWest Series final, Lord's, 2002\r\nIndia won by 2 wickets\r\nWe call this ODI NatWest. Just NatWest - which covers not one match but a passage of history whirling with emotion. India… [+8993 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Real Champs"
        },
        "author": "Avradeep Mukherjee",
        "title": "Real Madrid confirm major boost for derby vs Atletico - The Real Champs",
        "description": "On the eve of the derby, the main talking point around Real Madrid was whether Jude Bellingham and Vinicius Junior would be fully fit for the pivotal game ...",
        "url": "https://therealchamps.com/2023/09/24/real-madrid-confirm-boost-derby-atletico/",
        "urlToImage": "https://images2.minutemediacdn.com/image/fetch/w_2000,h_2000,c_fit/https%3A%2F%2Ftherealchamps.com%2Fwp-content%2Fuploads%2Fgetty-images%2F2017%2F07%2F1240964788.jpeg",
        "publishedAt": "2023-09-24T01:54:44Z",
        "content": "On the eve of the derby, the main talking point around Real Madrid was whether Jude Bellingham and Vinicius Junior would be fully fit for the pivotal game against crosstown rivals Atletico Madrid awa… [+2017 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Zoom"
        },
        "author": "TN Sports Desk",
        "title": "Not Shaheen Afridi Or Amir! Rohit Sharma Picks Ex-RCB Star As 'Most Challenging Bowler' To Face - Times Now",
        "description": "Indian skipper Rohit Sharma has ignored left-arm pacers like Pakistan's Shaheen Shah Afridi and Mohammad Amir to instead pick a former South African and RCB legend as the most challenging bowler to face. According to Rohit, Dale Steyn is the most challenging …",
        "url": "https://www.timesnownews.com/sports/cricket/not-shaheen-shah-afridi-or-mohammad-amir-rohit-sharma-picks-dale-steyn-as-most-challenging-bowler-article-103898608",
        "urlToImage": "https://static.tnn.in/thumb/msid-103898608,updatedat-1695519369764,width-1280,height-720,resizemode-75/103898608.jpg",
        "publishedAt": "2023-09-24T01:36:09Z",
        "content": "Suryakumar Yadav Joins Zaheer Khan, Rohit Sharma In Rare List After Four Consecutive Sixes Off Cameron Green"
    },
    {
        "source": {
            "id": null,
            "name": "Pain In The Arsenal"
        },
        "author": "Harry Dowsett",
        "title": "3 reasons why playing against 'Ange Ball' could be perfect for Arsenal in NLD - Pain In The Arsenal",
        "description": "Arsenal play host to the first North London derby of the 2023/24 campaign, welcoming Tottenham Hotspur to the Emirates Stadium for the first time under Ang...",
        "url": "https://paininthearsenal.com/2023/09/24/3-reasons-arsenal-tottenham-north-london-derby/",
        "urlToImage": "https://images2.minutemediacdn.com/image/fetch/w_2000,h_2000,c_fit/https%3A%2F%2Fpaininthearsenal.com%2Fwp-content%2Fuploads%2Fgetty-images%2F2017%2F07%2F1657383537-scaled.jpeg",
        "publishedAt": "2023-09-24T01:33:25Z",
        "content": "Arsenal play host to the first North London derby of the 2023/24 campaign, welcoming Tottenham Hotspur to the Emirates Stadium for the first time under Ange Postecoglou. \r\nBoth sides come into the cl… [+1768 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Mihir Vasavda at Asian Games: At China’s virtual show, digital torchbearer lights flame, river flows inside stadium - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/sports/chinas-virtual-show-digital-torchbearer-lights-flame-river-flows-inside-stadium-8953288/",
        "urlToImage": null,
        "publishedAt": "2023-09-23T22:34:57Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Sporting News"
        },
        "author": null,
        "title": "Revealed: Sergio Reguilon battled on & played 79 minutes for Man Utd vs Burnley despite being ill - and it made big impression on Erik ten Hag - GOAL English",
        "description": "Get all the latest Soccer news, highlights, scores, schedules, standings and more from Sporting News Canada.",
        "url": "https://www.sportingnews.com/ca/soccer",
        "urlToImage": "https://static.sportingnews.com/1.37.0.8/themes/custom/tsn/logo.jpg",
        "publishedAt": "2023-09-23T22:13:02Z",
        "content": null
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "Sportstar",
        "title": "ISL 2023-24: Why is Mohun Bagan Super Giant vs Punjab FC kick-off delayed? - Sportstar",
        "description": null,
        "url": "https://sportstar.thehindu.com/football/indian-football/mohun-bagan-vs-punjab-fc-kick-off-delay-reason-broadcast-issue-ofc-v-cfc-isl-2023-24-match/article67338563.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-23T20:28:03Z",
        "content": null
    },
    {
        "source": {
            "id": "espn-cric-info",
            "name": "ESPN Cric Info"
        },
        "author": "Mohammad Isam",
        "title": "'Don't think it looks good to bring back a batter after getting him out' - Tamim on recalling Sodhi - ESPNcricinfo",
        "description": "Tamim also said Bangladesh need not have given Sodhi a warning, and that the team would be discussing if they wanted to stick to this mode of dismissal in the future",
        "url": "https://www.espncricinfo.com/story/tamim-iqbal-on-recalling-ish-sodhi-after-run-out-at-non-strikers-end-dont-think-it-looks-good-1399772",
        "urlToImage": "https://img1.hscicdn.com/image/upload/f_auto/lsci/db/PICTURES/CMS/367600/367663.6.jpg",
        "publishedAt": "2023-09-23T18:30:58Z",
        "content": "NewsTamim also said Bangladesh need not have given Sodhi a warning, and that the team would be discussing if they wanted to stick to this mode of dismissal in the future\r\nMohammad Isam is ESPNcricinf… [+36 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Moneycontrol"
        },
        "author": "Moneycontrol News",
        "title": "ICC ODI World Cup 2023: A look at all 10 venues - Moneycontrol",
        "description": "The upcoming ODI World Cup 2023 will be played across 10 venues in India as 10 teams will battle for the biggest prize in the 50-over format. We take a look at the arenas that will host the ICC Men's ODI World Cup.",
        "url": "https://www.moneycontrol.com/news/cricket/icc-odi-world-cup-2023-a-look-at-all-10-venues-11415931.html",
        "urlToImage": "https://images.moneycontrol.com/static-mcnews/2021/02/EumYf-JVoAcmKKF-770x433.png",
        "publishedAt": "2023-09-23T18:09:46Z",
        "content": "India will host the 13th edition of the ICC Mens Cricket World Cup across 10 iconic venues as hordes of passionate fans will watch the biggest cricketers on the planet put on a show for their respect… [+7224 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India.com"
        },
        "author": "ANI",
        "title": "International Cricket Stadium In Varanasi Will Boost Economy Of Purvanchal: PM Modi - Zee News",
        "description": "Prime Minister Narendra Modi on Saturday said that the International Cricket Stadium in Varanasi will not only benefit sportspersons but also boost the economy of eastern Uttar Pradesh (Purvanchal). Laying the foundation stone of the International Cricket Sta…",
        "url": "https://zeenews.india.com/india/international-cricket-stadium-in-varanasi-will-boost-economy-of-purvanchal-pm-modi-2666254.html",
        "urlToImage": "https://english.cdn.zeenews.com/sites/default/files/2023/09/23/1287029-varanasi-india-cricket-stadium.jpg",
        "publishedAt": "2023-09-23T17:50:00Z",
        "content": "Varanasi: Prime Minister Narendra Modi on Saturday said that the International Cricket Stadium in Varanasi will not only benefit sportspersons but also boost the economy of eastern Uttar Pradesh (Pur… [+3076 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "ESPN India"
        },
        "author": "Rob Dawson",
        "title": "Guardiola angry with Rodri after red card in Forest win - ESPN - ESPN India",
        "description": "Pep Guardiola has revealed Rodri apologised to his team-mates following his red card against Nottingham Forest and said he was \"angry\" with the midfielder for leaving Manchester City with 10 men.",
        "url": "https://www.espn.in/football/story/_/id/38469811/guardiola-angry-rodri-red-card-forest-win",
        "urlToImage": "https://a1.espncdn.com/combiner/i?img=%2Fphoto%2F2023%2F0923%2Fr1228584_1296x729_16%2D9.jpg",
        "publishedAt": "2023-09-23T17:41:00Z",
        "content": "Pep Guardiola has said Rodri apologised to his teammates following his red card against Nottingham Forest and admitted he was \"angry\" with the midfielder for leaving Manchester City with 10 men.\r\nCit… [+1732 chars]"
    }
]


export default sports;